import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthenticationService } from '@app/auth/services/authentication.service';

@Component({
  selector: 'app-list-travel-expenses',
  templateUrl: './list-travel-expenses.component.html',
  styleUrls: ['./list-travel-expenses.component.scss']
})
export class ListTravelExpensesComponent implements AfterViewInit {
  isUpdateOperation = false;
  constructor(public authService: AuthenticationService) {}

  ngAfterViewInit() {}
}
